export default (theme) => {
  return {
    container: {
      display: 'flex',
      alignItems: 'center',
      color: 'white',
    },
  }
}
